/* unplugin-vue-components disabled */import { render } from "./exam-Oral.vue?vue&type=template&id=a53c98a2&scoped=true"
import script from "./exam-Oral.vue?vue&type=script&lang=js"
export * from "./exam-Oral.vue?vue&type=script&lang=js"

import "./exam-Oral.vue?vue&type=style&index=0&id=a53c98a2&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a53c98a2"]])

export default __exports__